import {  
  loadControllerPermissionsDataInProgress,
  loadAppRolesDataSuccess,
  loadControllersListDataSuccess,
  loadRoleControllerPermissionsDataSuccess,
  loadControllerTenantPermissionDataSuccess,
  loadControllerPermissionsDataFailure,
  loadTenantRoleDataSuccess,
  controllerPermissionsOperationCompleted
} from "../state/controllerpermissions/actions";
import configData from "../config.json";
import { errorSweetAlert, oopsSweetAlert } from "../components/SweetAlertMessages";
import swal from "sweetalert";
import { oktaAuth } from '../auth/okta';
const serverBasePath = configData.SERVER_API_URL;

export const loadAppRolesList = () => async (dispatch) => {
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  try {
    dispatch(loadControllerPermissionsDataInProgress());
    const response = await fetch(serverBasePath+"/permission/appRoles",
    { 
      method: "GET",
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
      }
    });

    if(response.status===401){
      window.location.reload(false);
      return;
    }
    const data = await response.json();
    dispatch(loadAppRolesDataSuccess(data));
  } catch (e) {       
    dispatch(loadControllerPermissionsDataFailure());
    errorSweetAlert(e);
  }
};


export const loadControllersList = () => async (dispatch) => {
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  try {
    dispatch(loadControllerPermissionsDataInProgress());
    const response = await fetch(serverBasePath+"/permission/getControllersList",
    { 
      method: "GET",
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
      }
    });
    if(response.status===401){
      window.location.reload(false);
      return;
    }
    const data = await response.json();
    dispatch(loadControllersListDataSuccess(data));
  } catch (e) {       
    dispatch(loadControllerPermissionsDataFailure());
    errorSweetAlert(e);
  }
};


export const loadControllerRolePermissionsList = (tenantId,tenantRoleId) => async (dispatch) => {
    const token = oktaAuth.getAccessToken(); 
    if (!token) throw new Error('No access token');
    try {
      //dispatch(loadAccessDataInProgress());
      dispatch(loadControllerPermissionsDataInProgress());
      const response = await fetch(serverBasePath+"/permission/controller/tenant/"+tenantId+"/tenantrole/"+tenantRoleId,
      {
          method: "GET",
          headers: {
          Authorization: 'Bearer ' + token,
              'Content-Type': 'application/json',
          },
      });
  
        if(response.status===401){
          window.location.reload(false);
          return;
        }
       const data = await response.json();
       //console.log('data',data)
       dispatch(loadRoleControllerPermissionsDataSuccess(data));
    } catch (e) {   
      dispatch(loadControllerPermissionsDataFailure());
      errorSweetAlert(e);
    }
  };


  export const updateControllerRolePermissions = (idList,controllerRolePermission) => async (dispatch) => {
    const token = oktaAuth.getAccessToken(); 
    if (!token) throw new Error('No access token');
    let data = {
      'tenantId' : idList.tenantId,
      'tenantRoleId' : idList.tenantRoleId,
      'controllerRolePermission' : controllerRolePermission
    }
    dispatch(loadControllerPermissionsDataInProgress());
    try {
        const response = await fetch(serverBasePath+"/permission/updateControllerRolePermissions", 
        {
            method: "PUT",  
            headers: {
              Authorization: 'Bearer ' + token,       
              'Content-Type': 'application/json',
            },
            body:JSON.stringify(data)
        });
        dispatch(controllerPermissionsOperationCompleted());
        const result = await response.json();
        if(response.status !== 200){
            oopsSweetAlert(result);
            return;
        }
        
        swal({
            title: "Success",
            text: result.message,
            icon: "success",
            closeOnClickOutside:false,
            closeOnEsc: false,
            allowOutsideClick: false,
        }).then(marked => {
          // if (marked) {
          //   //dispatch(loadRolePermissionsList(roleId));
          // }
        });
    } catch (e) {
        dispatch(loadControllerPermissionsDataFailure());
        errorSweetAlert(e);
    }
  };

  export const loadTenantRolesList = (tenantId) => async (dispatch) => {
    const token = oktaAuth.getAccessToken(); 
    if (!token) throw new Error('No access token');
    try {
      dispatch(loadControllerPermissionsDataInProgress());
      const response = await fetch(serverBasePath+"/permission/getTenanatRolesList/"+tenantId,
      { 
        method: "GET",
        headers: {
          Authorization: 'Bearer ' + token,
          'Content-Type': 'application/json',
        }
      });
      const data = await response.json();
      dispatch(loadTenantRoleDataSuccess(data));
    } catch (e) {       
      dispatch(loadControllerPermissionsDataFailure());
      errorSweetAlert(e);
    }
  };



  export const loadControllerTenantPermission = (tenantId,tenantRoleId) => async (dispatch) => {
    const token = oktaAuth.getAccessToken(); 
    if (!token) throw new Error('No access token');
    try {
      //dispatch(loadAccessDataInProgress());
      dispatch(loadControllerPermissionsDataInProgress());
      const response = await fetch(serverBasePath+"/permission/tenant/"+tenantId+"/tenantrole/"+tenantRoleId,
      {
          method: "GET",
          headers: {
          Authorization: 'Bearer ' + token,
              'Content-Type': 'application/json',
          },
      });
  
        if(response.status===401){
          window.location.reload(false);
          return;
        }
       const data = await response.json();
       //console.log('data',data)
       dispatch(loadControllerTenantPermissionDataSuccess(data));
    } catch (e) {   
      console.log('error',e)    
     // dispatch(loadAccessDataFailure());
      dispatch(loadControllerPermissionsDataFailure());
      errorSweetAlert(e);
    }
  };

